var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.upsellToGo3)?_c('a',{staticClass:"c-upsell-button o-button o-button--player",class:{ 'c-upsell-button--embedded': _vm.isEmbedded },attrs:{"href":_vm.url,"target":"_blank"}},[_c('span',{staticClass:"o-button__label c-upsell-button__label"},[_vm._v(" "+_vm._s(_vm.$t('player.upsell'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }